import { getValidNumber } from './formatNumber';

export const formatUsdValue = (price: number | null | undefined, noDecimals?: boolean): string => {
  const { isValid, value } = getValidNumber(price);

  if (!isValid || value === null) {
    return '$ 0.00';
  }

  const formatted = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: noDecimals ? 0 : 2,
    maximumFractionDigits: noDecimals ? 0 : 2,
  }).format(value);

  return formatted.replace('$', '$ ');
};
